export class Environment {
  public static env(): string | undefined {
    return process.env.NEXT_PUBLIC_ENV;
  }

  public static isLocal(): boolean {
    return process.env.NEXT_PUBLIC_ENV === "local";
  }

  public static isStage(): boolean {
    return process.env.NEXT_PUBLIC_ENV === "stage";
  }

  public static isProd(): boolean {
    return process.env.NEXT_PUBLIC_ENV === "prod";
  }
}
